import React, { Component } from "react";
import { Box } from "@mui/material";
import { motion } from "framer-motion";

class GoalRaisedAmountBar extends Component {
  render() {
    const { goalAmount, raisedAmount } = this.props;

    // Raised percentage (max 100% for bar fill)
    const raisedAmountPercentage = Math.min(
      (raisedAmount / goalAmount) * 100,
      96
    );

    // Goal marker position
    const goalAmountPercentage =
      raisedAmount > goalAmount ? (goalAmount / raisedAmount) * 100 : 90;

    // ✅ Dynamic colors
    const barBackground =
      raisedAmount > goalAmount
        ? "linear-gradient(90deg,  #96ee4f, #468d0c)" // Dark green gradient
        : "#7ed23a";

    const goalLineColor =
      raisedAmount > goalAmount
        ? "linear-gradient(90deg, #96ee4f, #468d0c)"
        : "#eee";

    return (
      <Box sx={{ width: "100%", position: "relative", padding: "16px 0px" }}>
        {/* Raised Label */}
        <motion.div
          initial={{ left: "4%" }}
          animate={{ left: `${raisedAmountPercentage}%` }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          style={{
            width: "max-content",
            position: "absolute",
            transform: "translateX(-50%)",
            top: "-10%",
            color: "#353538",
            fontWeight: "600",
            fontSize: "14px",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <span>Raised: ${raisedAmount.toLocaleString()}</span>
          <i
            className="fa fa-caret-down"
            style={{
              fontSize: "16px",
              marginTop: "-2px",
              textAlign: "center",
            }}
          ></i>
        </motion.div>

        {/* Bar */}
        <Box
          sx={{
            width: "100%",
            height: "32px",
            borderRadius: "20px",
            background: "#eee",
            overflow: "hidden",
            position: "relative",
            margin: "10px 0px",
          }}
        >
          {/* Raised Fill */}
          <motion.div
            initial={{ width: "4%" }}
            animate={{ width: `${raisedAmountPercentage}%` }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
            style={{
              height: "100%",
              background: barBackground, // ✅ Dynamic bar color
            }}
          />

          {/* Goal Vertical Line */}
          <motion.div
            initial={{ left: "90%" }}
            animate={{ left: `${goalAmountPercentage}%` }}
            transition={{ duration: 0.8, ease: "easeInOut" }}
            style={{
              position: "absolute",
              top: 0,
              bottom: 0,
              width: "3px",
              background: "#cccc", // ✅ Dynamic goal line color
              transform: "translateX(-50%)",
            }}
          />
        </Box>

        {/* Goal Marker */}
        <motion.div
          initial={{ left: "90%" }}
          animate={{ left: `${goalAmountPercentage}%` }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          style={{
            width: "max-content",
            position: "absolute",
            transform: "translateX(-50%)",
            fontWeight: "600",
            fontSize: "14px",
            color: "#353538",
            textAlign: "center",
            bottom: "-12%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <i
            className="fa fa-caret-up"
            style={{
              fontSize: "16px",
              marginBottom: "-2px",
              textAlign: "center",
            }}
          ></i>
          <span>Goal: ${goalAmount.toLocaleString()}</span>
        </motion.div>
      </Box>
    );
  }
}

export default GoalRaisedAmountBar;
